import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useNavigation } from '../../utilities/NavigationContext';
import { useAuth } from '../../utilities/AuthContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EndPoint = process.env.REACT_APP_API_ENDPOINT;

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        email: '',
        };
    }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        const { email } = this.state;
        

        try {
            const response = await axios.post(`${EndPoint}/user/forgot-password`, { email });

            if (response.status === 200) {
                toast.success(response.data.message, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                hideProgressBar : false
                });
        
                // this.props.setAuth(prevAuth => ({ ...prevAuth, isLoggedIn: true }));
                // this.props.navigate('/patientselect');
            } else {
                toast.error(error, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                hideProgressBar : false
                });
        
            }
        } catch (error) {
            
        toast.error(error.response.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            hideProgressBar : false
        });
        }
    };


    render() {
        return (
        <div>
            <div className='absolute -mt-56 -ml-[900px] bg-gradient-to-b from-sky-700 via-sky-800 to-sky-900 w-[1500px] h-[1500px] rounded-xl rotate-20 opacity-30 z-40 xs:hidden sm:hidden'></div>
            <div className='absolute -mt-64 -ml-[800px] bg-gradient-to-b from-sky-700 via-sky-800 to-sky-900 w-[1500px] h-[1500px] rounded-xl rotate-20 opacity-30 z-40 xs:hidden sm:hidden'></div>
            <div className='flex flex-col items-center h-screen bg-gradient-to-b from-sky-900 to-sky-800 py-16'>
            <ToastContainer />
            <form onSubmit={this.handleSubmit} className='flex flex-col gap-4 mt-6  p-10'>
            <h2 className='text-3xl my-10 text-sky-300 font-semibold text-center z-50'>Forgot Password ?</h2>
            <h3 className='text-xl mt=10- text-sky-200 text-center z-50'>Enter your registered email to reset your password</h3>
       
            <input
                type="email"
                name="email"
                placeholder="Email"
                value={this.state.email}
                onChange={this.handleInputChange}
                required
                className='rounded border border-sky-700 bg-sky-800 p-4 text-sky-100 text-sm m-6 placeholder:text-sky-400 focus:border-sky-600 z-50'
            />
            
            <div className='text-center'><button type="submit" className='text-white bg-sky-600 hover:bg-sky-700 rounded shadow-sm w-32 p-2 m-1'>Reset Password</button></div>
            <p className='text-center text-sky-400'>Remember your password? <button onClick={()=> {  this.props.navigate('/login');}} className='text-red-400 hover:text-red-500'>Login here</button></p>
            </form>
            <div className='py-4 inline-block text-sky-400'>Don't have an account? <div className='text-red-400 hover:text-red-500'><Link to="/register">Click here to register.</Link></div></div>
        </div>
     
        </div>
        );
    }
}

// Higher-order component to consume the NavigationContext
const ForgotPasswordWithNavigation = (props) => {
  const navigate = useNavigation();
  const [, setAuth] = useAuth(); // Get the setAuth function from AuthContext

  return <ForgotPassword {...props} navigate={navigate} setAuth={setAuth} />;
};

export default ForgotPasswordWithNavigation;
